/**
 * 此專案僅部署於 where（或本機開發）。
 * 公開追蹤：GetLastLocationEta — GET {base}/tracking/last-location-eta
 * （Query：attributes, debug, examine, trackingCode；回應 module + payload.data）
 */
function trackingApiBase(): string {
    if (typeof window === 'undefined') {
        return 'https://where.ai-routing-si.com/api';
    }
    const h = window.location.hostname;
    if (h === 'localhost' || h === '127.0.0.1' || h === '172.16.0.12') {
        return 'http://172.16.2.31:14211';
    }
    return 'https://where.ai-routing-si.com/api';
}

/** 與 lineoa 相同：追蹤請求失敗時可退回此基底（多數環境與 TRACKING 相同） */
export const API_BASE_URL = trackingApiBase();

export const TRACKING_API_BASE_URL = trackingApiBase();

export const DEBUG =
    typeof window !== 'undefined' &&
    (window.location.hostname === 'localhost' ||
        window.location.hostname === '127.0.0.1' ||
        window.location.hostname === '172.16.0.12');

export function shouldSendCloudFrontSecretForUrl(url: string): boolean {
    return (
        url.includes('ai-routing-si.com') ||
        url.includes('www.ai-routing.com') ||
        url.includes('ai-routing.com')
    );
}
